import { supportWebpDomain } from '@/constants/url';
import { checkWebPSupport } from 'supports-webp-sync'

const IMAGE_FORMAT = {
  webp: 'webp',
};

// 可以根据需要添加更多的域名和格式
const domainFormatMap: { [format: string]: string[] } = {
  [IMAGE_FORMAT.webp]: supportWebpDomain,
};

/* 拼接webp格式(原图ratio为"origin") */
export const convertToWebP = (url: string, ratio?: string) => {
  if (!url) return url;
  if (/\.gif/i.test(url)) {
    // 如果是gif格式，裁剪掉.gif后面的所有内容
    return url.replace(/\.gif.*/i, '.gif');
  }
  // 使用正则表达式来匹配图片 URL 分为两部分：主路径(eg:https://xxx.jpg)和样式标识(eg:@!1200 或 @!200x200)
  const regex = /^(.+)(@!)([0-9x]+)/;
  const match = url.match(regex);

  if (!match || match.length < 4) {
    // 如果 URL 不符合格式，直接拼接传入的分辨率的webp格式
    return `${url}@!${ratio || 'origin'}webp`;
  }

  const [_, base, __, style] = match;

  const newUrl = `${base}@!${ratio || style || 'origin'}webp`;

  return newUrl;
}

/* 
  * 判断是否支持webp
  * @pram url, format, ratio {string, string, string} - 图片地址, 图片格式, 分辨率
  * @return string
  * 传入url,判断如果当前url域名支持webp且当前浏览器支持webp,则返回webp格式的url,否则返回原始url
  * 返回的webp格式ur根据传入的分辨率(优先)或者原始url的分辨率拼接
*/
export const getOptimizedImageUrl = (url: string, format?: string, ratio?: string) => {
  if (!url) return url;
  const domain = new URL(url).hostname;
  const targetFormat = format ? format : IMAGE_FORMAT.webp;

  // 确定 URL 的域名支持哪些格式
  const supportedFormats = Object.keys(domainFormatMap).filter(format => {
    return domainFormatMap[format].includes(domain);
  });

  // 检测浏览器支持的格式
  const browserSupportedFormats = supportedFormats.filter(format => {
    if (format === IMAGE_FORMAT.webp) return checkWebPSupport();
    // 如果后面添加了 avif 等格式，可以在这里添加相应的检测
    return false;
  });

  // 返回处理后的 URL
  if (browserSupportedFormats.length > 0 && browserSupportedFormats.includes(targetFormat)) {
    if (targetFormat === IMAGE_FORMAT.webp) {
      return convertToWebP(url, ratio);
    }
    // 如果后面添加了 avif 等格式，可以在这里添加相应的处理逻辑
    return url;
  }

  // 如果没有找到支持的格式，返回原始 URL
  return url;
};
